

/* import 'babel-polyfill' */
import Vue from 'vue'
import App from './App'
import router from './router'
/* import jquery from 'jquery' */
import ToastPlugin from 'vux/src/plugins/toast/index.js'


/*import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min.js'*/
import './assets/theme.css'
/*import './assets/jquery.min.js'*/


Vue.config.productionTip = false
Vue.config.debug = true;

Vue.prototype.HOST = '/json'

Vue.use(ToastPlugin)

/* Vue.use(jquery)  */

/* eslint-disable no-new */
new Vue({
el: '#app',
router,
template: '<App/>',
components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js